import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

const DropZoneMultipleField = ({ name, value, onChange }) => {

  const validateURLPreview = (file) => {
    let extension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
    if(extension == "png" || extension == "jpeg" || extension == "jpg" || extension == "bmp")
    {
      return file.preview;
    }
    else
    {
      return `${process.env.PUBLIC_URL}/img/fileDefualt.png`;
    }
  }

  const files = value;
  const onDrop = (onDropFiles) => {
    onChange(onDropFiles.map(fl => Object.assign(fl, {
      preview: URL.createObjectURL(fl),
    })));
  };
  const removeFile = (index, e) => {
    e.preventDefault();
    onChange(value.filter((val, i) => i !== index));
  };

  return (
    <div className="dropzone dropzone--multiple">
      <Dropzone
        className="dropzone__input"
        accept=".jpg,.png,.jpeg,.bmp,.dcm"
        name={name}
        onDrop={(filesToUpload) => {
          onDrop(value ? value.concat(filesToUpload) : filesToUpload);
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="dropzone__input">
            {(!files || files.length === 0)
            && (
              <div className="dropzone__drop-here">
                <h3><span className="lnr lnr-upload" />Arrastrar o adjuntar los archivos a subir</h3>
              </div>
            )}
            <input {...getInputProps()} />
          </div>
        )}
      </Dropzone>
      {files && Array.isArray(files)
      && (
        <div className="dropzone__imgs-wrapper">
          {files.map((file, i) => (
            <div className="dropzone__img" key={file.i} style={{ backgroundImage: `url(${validateURLPreview(file)})` }}>
              {console.log("filePreview",file)}
              <p className="dropzone__img-name">{file.name}</p>
              <button className="dropzone__img-delete" type="button" onClick={e => removeFile(i, e)}>
                X
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

DropZoneMultipleField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      files: PropTypes.string,
    })),
  ]).isRequired,
};

const renderDropZoneMultipleField = ({ input }) => <DropZoneMultipleField {...input} />;

renderDropZoneMultipleField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
};

export default renderDropZoneMultipleField;
